import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCoffee, faCartPlus} from '@fortawesome/free-solid-svg-icons'
import './Card.css'

const Card = (props) => {
    // console.log(props);
    const {name, famous, available, birthdate, birthplace, died, century, image} = props.poet;
    const element = <FontAwesomeIcon icon={faCartPlus} />
    return (
        <div>
            <div className="card">
                <img className="card-img" src={image} alt={name} />
                <div className="card-text">
                <h4>Name: {name}</h4>
                <p>Famous for: {famous}</p>
                <p>Birthdate: {birthdate}</p>
                <p>Birth Place: {birthplace}</p>
                <p>Died: {died}</p>
                <p>Available book here: {available}</p>
                </div>
                <button onClick={() =>props.cartDetailsHandel(props.poet)} className="card-btn">{element} Add all available book</button>
            </div>
        </div>
    );
};

export default Card;